import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../lands/assets/img/hero-bg-2.jpg'
import _imports_1 from '../../lands/assets/img/hero-img.png'


const _hoisted_1 = {
  id: "hero",
  class: "hero section dark-background"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row gy-4 justify-content-between" }
const _hoisted_4 = { class: "col-lg-6 d-flex flex-column justify-content-center" }
const _hoisted_5 = { class: "d-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("img", {
      src: _imports_0,
      alt: "",
      class: "hero-bg"
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-lg-4 order-lg-last hero-img" }, [
          _createElementVNode("img", {
            src: _imports_1,
            class: "img-fluid animated",
            alt: ""
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("h1", null, [
            _createTextVNode("Payez vos droits de place en toute "),
            _createElementVNode("span", null, "Sécurité")
          ], -1)),
          _cache[3] || (_cache[3] = _createElementVNode("p", null, "Nous sommes disponible pour vous 24h/24", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/e-processus",
              class: "btn-get-started"
            }, {
              default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                _createTextVNode("Payer", -1)
              ]))]),
              _: 1
            }),
            _cache[1] || (_cache[1] = _createElementVNode("a", {
              href: "https://www.youtube.com/watch?v=IYVbN__C8YA",
              class: "glightbox btn-watch-video d-flex align-items-center"
            }, [
              _createElementVNode("i", { class: "bi bi-play-circle" }),
              _createElementVNode("span", null, "Vidéo")
            ], -1))
          ])
        ])
      ])
    ]),
    _cache[6] || (_cache[6] = _createStaticVNode("<svg class=\"hero-waves\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 24 150 28 \" preserveAspectRatio=\"none\"><defs><path id=\"wave-path\" d=\"M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z\"></path></defs><g class=\"wave1\"><use xlink:href=\"#wave-path\" x=\"50\" y=\"3\"></use></g><g class=\"wave2\"><use xlink:href=\"#wave-path\" x=\"50\" y=\"0\"></use></g><g class=\"wave3\"><use xlink:href=\"#wave-path\" x=\"50\" y=\"9\"></use></g></svg>", 1))
  ]))
}